<template>
  <div @click="containerClicked($event)" id="add-edit-project">
    <div class="content-wrapper">
      <div class="page-heading">
        <h1 v-if="!isUpdateProject" class="page-title">
          {{ $t("message.addProject") }}
        </h1>
        <h1 v-if="isUpdateProject" class="page-title">
          {{ $t("message.editProject") }}
        </h1>
      </div>
      <div class="page-content fade-in-up">
        <div class="row">
          <modals-container></modals-container>

          <div class="col-md-12">
            <div class="ibox" :style="{ backgroundColor: project.color }">
              <div class="ibox-body">
                <div class="tab-pane fade active show">
                  <div class="row">
                    <div class="col-md-5">
                      <table>
                        <tr v-if="isUpdateProject">
                          <td>
                            <div
                              class="go-back"
                              @click="goToLock"
                              style="
                                white-space: nowrap;
                                margin-top: -10px;
                                margin-left: -10px;
                                margin-bottom: 10px;
                              "
                            >
                              <i
                                style="padding: 3px"
                                class="fa fa-external-link"
                              ></i>
                              <span class="backToButton" style="padding: 3px">{{
                                $t("message.goToLockMonths")
                              }}</span>
                            </div>
                          </td>
                          <td>
                            <div
                              class="go-back"
                              @click="goToTaskHistory"
                              style="
                                white-space: nowrap;
                                margin-top: -10px;
                                margin-left: -10px;
                                margin-bottom: 10px;
                              "
                            >
                              <i
                                style="padding: 3px"
                                class="fa fa-external-link"
                              ></i>
                              <span class="backToButton" style="padding: 3px">{{
                                $t("message.goToTaskHistory")
                              }}</span>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td valign="bottom">
                            <label>{{ $t("message.projectName") }}:</label>
                          </td>
                          <td width="200px">
                            <input
                              type="text"
                              v-model="project.name"
                              class="form-control"
                              :placeholder="$t('message.projectName')"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td valign="bottom">
                            <label>{{ $t("message.startDate") }}:</label>
                          </td>
                          <td>
                            <input
                              id="start-date"
                              v-model="project.start_date"
                              type="text"
                              class="form-control"
                            />
                            <month-picker
                              :default-month="defaultStartDate.month"
                              :default-year="defaultStartDate.year"
                              v-show="showMonthPicker && startDate"
                              :lang="$store.getters.getLocale"
                              @change="setDate($event, project, 'start_date')"
                            ></month-picker>
                          </td>
                        </tr>
                        <tr>
                          <td valign="bottom">
                            <label>{{ $t("message.endDate") }}:</label>
                          </td>
                          <td>
                            <input
                              id="end-date"
                              v-model="project.end_date"
                              type="text"
                              class="form-control"
                            />
                            <month-picker
                              :default-month="defaultEndDate.month"
                              :default-year="defaultEndDate.year"
                              v-show="showMonthPicker && endDate"
                              :lang="$store.getters.getLocale"
                              @change="setDate($event, project, 'end_date')"
                            ></month-picker>
                          </td>
                        </tr>
                        <tr>
                          <td valign="bottom">
                            <label>{{ $t("message.targetCost") }}:</label>
                          </td>
                          <td width="200px">
                            <input
                              style="text-align: right"
                              type="text"
                              :value="formatNumber(project.target_cost)"
                              class="form-control"
                              :placeholder="$t('message.targetCost')"
                              disabled
                            />
                          </td>
                        </tr>
                        <tr>
                          <td valign="bottom">
                            <label>{{ $t("message.staticBudget") }}:</label>
                          </td>
                          <td width="200px">
                            <input
                              style="text-align: right"
                              type="text"
                              :value="formatNumber(project.static_budget)"
                              class="form-control"
                              :placeholder="$t('message.staticBudget')"
                              disabled
                            />
                          </td>
                        </tr>
                        <tr>
                          <td valign="bottom">
                            <label
                              >{{
                                $t("message.totalCostsProjectLeader")
                              }}:</label
                            >
                          </td>
                          <td width="200px">
                            <!-- <money v-bind="money"
                                                        style="text-align:right"
                                                        v-model="project.total_costs_project_leader"
                                                        class="form-control">
                                                         </money> -->
                            <formatted-input
                              :value="project.total_costs_project_leader"
                              :disabled="false"
                              @emit-value="updateTotalCostsProjectLeader"
                              :key="componentKey"
                            ></formatted-input>
                          </td>
                        </tr>

                        <tr>
                          <td valign="bottom">
                            <label
                              >{{ $t("message.projectController") }}:</label
                            >
                          </td>
                          <td>
                            <select
                              style="width: 230px"
                              v-model="project.created_by"
                            >
                              <option disabled value="">
                                {{ $t("message.plsSelectOne") }}
                              </option>
                              <option
                                v-for="superuser in superusers"
                                :value="superuser.id"
                                :key="superuser.id"
                              >
                                {{ superuser.first_name }}
                                {{ superuser.last_name }}
                              </option>
                            </select>
                          </td>
                        </tr>

                        <tr>
                          <td valign="top">
                            <label>{{ $t("message.description") }}:</label>
                          </td>
                          <td width="200px">
                            <textarea
                              rows="5"
                              cols="25"
                              v-model="project.description"
                              :placeholder="$t('message.description')"
                            >
                            </textarea>
                          </td>
                        </tr>
                        <tr v-if="isUpdateProject">
                          <td valign="middle">
                            <label>{{ $t("message.sendEmailAlerts") }}:</label>
                          </td>
                           <td>
                              <label class="switch">
                                <input
                                  type="checkbox"
                                  v-model="project.send_email_alerts"
                                  @change="updateSendEmailAlerts()"
                                />
                                <span class="slider"></span>
                              </label>
                            </td>
                        </tr>
                      </table>
                    </div>
                    <div class="col-md-4">
                      <div
                        v-if="isUpdateProject"
                        class="form-group"
                        style="margin-top: 37px"
                      >
                        <label>{{ $t("message.addUpdateCoverImage") }}</label>
                        <br />
                        <button
                          style="cursor: pointer"
                          @click="$refs.imageInput.click()"
                          class="btn btn-primary"
                        >
                          {{ $t("message.addUpdate") }}
                        </button>
                        <input
                          type="file"
                          style="display: none"
                          @input="addImage"
                          id="imageInput"
                          ref="imageInput"
                        />
                      </div>
                      <div class="row">
                        <div class="col-md-6 mt-3 mb-4">
                          <div>
                            <label style="font-weight: bold">{{
                              $t("message.projectStatus")
                            }}</label>
                          </div>
                          <div>
                            <label class="ui-checkbox ui-checkbox-success">
                              <input v-model="project.status" type="checkbox" />
                              <span class="input-span"></span
                              ><span
                                style="font-weight: normal; color: #2ecc71"
                                v-if="project.status"
                                >{{ $t("message.active") }}</span
                              ><span
                                style="font-weight: normal; color: red"
                                v-if="!project.status"
                                >{{ $t("message.notActive") }}</span
                              ></label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="form-group" style="margin-top: 70px">
                        <label>{{ $t("message.addUpdateProjectColor") }}</label>
                        <br />
                        <div class="form-group">
                          <color-picker-modal
                            @emitColor="emitColor"
                            :projectColor="project.color"
                          ></color-picker-modal>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12 text-center">
                      <button
                        v-if="!isUpdateProject"
                        style="margin: 1%"
                        @click="addUpdateProject"
                        class="btn btn-primary"
                      >
                        {{ $t("message.add") }}
                      </button>
                      <button
                        v-if="isUpdateProject"
                        style="margin: 1%"
                        @click="addUpdateProject"
                        class="btn btn-primary"
                      >
                        {{ $t("message.update") }} {{ $t("message.basicInfo") }}
                      </button>
                    </div>
                  </div>
                  <hr />
                  <div
                    v-if="$router.currentRoute.name === 'EditProject'"
                    class="row"
                  >
                    <div class="col-md-12 text-center mb-4 mt-2">
                      <h5 style="font-weight: bold">
                        {{ $t("message.addCraftsmenToProject") }}
                      </h5>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="">{{
                          $t("message.searchForCraftsmenByCompanyName")
                        }}</label>
                        <input
                          v-model="companyFilter"
                          @keyup="filterUsers"
                          type="text"
                          class="form-control"
                          :placeholder="`${$t('message.searchBy')} ${$t(
                            'message.companyName'
                          )}`"
                        />
                      </div>
                      <!--<div class="form-group">-->
                      <!--<label for="">{{$t('message.currentJobType')}}</label>-->
                      <!--<select v-model="jobFilter" @change="filterUsers"-->
                      <!--class="form-control">-->
                      <!--<option value=""></option>-->
                      <!--<option v-for="(job, index) in jobs" :key="index"-->
                      <!--:value="job.name">{{job.name}}-->
                      <!--</option>-->
                      <!--</select>-->
                      <!--</div>-->
                    </div>
                    <div class="col-md-8">
                      <div class="row">
                        <div class="col-md-6 text-center font-bold">
                          <p>{{ $t("message.selectCraftsmen") }}</p>
                        </div>
                        <div class="col-md-6 text-center font-bold">
                          <p>{{ $t("message.listOfUsersActiveOnProject") }}</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="companies-list-wrapper">
                            <ul
                              class="list-group"
                              v-for="(element, index) in usersList"
                              :key="index"
                            >
                              <li
                                class="list-group-item"
                                v-for="(job, index) in element.jobs"
                                :key="index"
                              >
                                {{ element.company_name }} - {{ job.name }}
                                <i
                                  @click="
                                    addUserToProjectDialog(element, job.name)
                                  "
                                  class="fa fa-plus-circle user-add"
                                ></i>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <!-- USERS ON PROJECT -->
                        <div class="col-md-6">
                          <ul class="list-group list-group-2">
                            <li
                              class="list-group-item"
                              v-for="(element, index) in usersOnProject"
                              :key="index"
                            >
                              <router-link
                                :to="{
                                  name: 'ActualCostsWork',
                                  params: {
                                    id: element.sheet,
                                    type: 'personnel',
                                    heading: 'work',
                                    lastRoute: 'EditProject',
                                    projectId: $route.params['id'],
                                  },
                                }"
                              >
                                {{ element.first_name }}
                                {{ element.last_name }},
                                {{ element.company_name }}
                                <span v-if="element.job.name !== ''"
                                  >, {{ element.job.name }}</span
                                ><span v-if="element.job.name === ''"
                                  >, {{ $t("message.noJobSelected") }}</span
                                >
                              </router-link>
                              <span
                                @click="removeFromListDialog(element)"
                                class="remove-from-list"
                                ><i class="fa fa-trash"></i
                              ></span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    v-if="isUpdateProject"
                    @click="downloadToCsv"
                    class="btn btn-success mr-2"
                    style="margin-top: 20px; margin-right: 15px"
                  >
                    {{ $t("message.downloadToCsv") }}
                  </button>
                   <button
                    v-if="isUpdateProject"
                    @click="createArchive"
                    class="btn btn-primary mr-2"
                    style="margin-top: 20px; margin-right: 15px"
                  >
                    {{ $t("message.createArchive") }}
                  </button> 
                  
                 <div v-if="isUpdateProject && archives.length > 0" class="row" style="margin-top:15px">
                     <div class="col-md-1"></div>
                     <div class="col-md-10 text-left">
                       <label>{{ $t("message.listArchivesCreated") }}</label>
                          <table class="table table-striped">
                              <thead>
                              <tr>
                                  <th scope="col"></th>
                                  <th scope="col">URL</th>
                                  <th scope="col">{{$t('message.created')}}</th>
                                  <th scope="col">{{$t('message.creationCompleted')}}</th>
                              </tr>
                              </thead>
                              <tbody v-if="archives.length !== 0">
                                  <tr v-for="(archive, index) in archives" :key="index">
                                      <td scope="col">{{index + 1}}</td>
                                      <td scope="col"><a :href="archive.url">{{ archive.url }}</a> </td>
                                      <td scope="col">{{ archive.created }}</td>
                                      <td scope="col"><span  style="margin-left:65px" :class="{'span completed':(archive.completed === true), 'span not-completed': (archive.completed === false)}"></span></td>
                                  </tr>
                              </tbody>
                           </table>
                    </div>
                     <div class="col-md-12">
                           <ul class="legend">
                              <li><span class="completed span"></span>{{ $t("message.completed") }}</li>
                              <li><span class="not-completed span"></span> {{ $t("message.notCompleted") }}</li>
                          </ul>
                    </div>
                  </div> 
                  <hr style="margin: 4%" />

                  <div v-if="isUpdateProject" class="row">
                    <div class="col-md-12 text-center">
                      <consolidation
                        v-if="project.id"
                        :stackedOptions="stackedOptions"
                        :stackedChartDataCollection="stackedChartDataCollection"
                        @confirmAutomaticContract="addUserToProject"
                        @confirmAdd="confirmAddUserToProject"
                        @confirmDelete="confirmDeleteUserFromProject"
                        show-link="true"
                        :chartOptions="chartOptions"
                        :horizontalBarDataCollection="
                          horizontalBarDataCollection
                        "
                        :barDataCollection="barDataCollection"
                        :consolidation-data="consolidationData"
                        :currentProject="project"
                        :mixedChartOptions="mixedChartOptions"
                        :mixedChartData="mixedChartDataCollection"
                        style="margin-left: 15px"
                        @refreshConsolidation="refreshConsolidation"
                      ></consolidation>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OkModal from "../../../modals/OkModal";
import DialogModal from "../../../modals/DialogModal";
import ColorPickerModal from "../../../modals/ColorPickerModal";
import Consolidation from "../projects/Consolidation";
import { MonthPicker } from "vue-month-picker";
import FormattedInput from "../../misc/FormattedInput";

export default {
  name: "AddEditProject",
  components: {
    Consolidation,
    MonthPicker,
    FormattedInput,
    ColorPickerModal,
  },
  data() {
    return {
      arrayOfColors: [
        "#ff7878",
        "#ff9178",
        "#ffae78",
        "#ffd278",
        "#fff478",
        "#d7ff78",
        "#b9ff78",
        "#95ff78",
        "#78ff93",
        "#78ffc9",
        "#78fffd",
        "#78c2ff",
        "#7883ff",
        "#a578ff",
        "#d478ff",
        "#ff78fa",
        "#ff7897",
        "#ff788c",
        "#a17474",
      ],
      stackedChartDataCollection: null,
      stackedOptions: {
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              return this.formatToolTipsHorizontalBars(tooltipItem, data);
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
            },
          ],
        },
      },
      archives: [],
      componentKey: 0,
      dontSetDateOnMount: false,
      showMonthPicker: false,
      setStartDateOnMount: false,
      setEndDateOnMount: false,
      mixedDates: [],
      superusers: [],
      mixedRollingForecastCosts: [],
      mixedTotalBudgetHistory: [],
      mixedChartDataCollection: null,
      defaultStartDate: {
        year: null,
        month: null,
      },
      defaultEndDate: {
        year: null,
        month: null,
      },
      endDate: false,
      startDate: false,
      altPic: "/assets/noImg.jpg",
      showToolTip: false,
      isUpdateProject: false,
      jobFilter: "",
      companyFilter: "",
      usersList: [],
      usersOnProject: [],
      consolidationData: {},
      jobs: [],
      horizontalBarDataCollection: null,
      barDataCollection: null,
      chartOptions: {
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              return this.formatToolTipsHorizontalBars(tooltipItem, data);
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value) {
                  return value
                    .toString()
                    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1’");
                },
              },
            },
          ],
        },
      },
      mixedChartOptions: {
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              return this.formatToolTipsHorizontalBars(tooltipItem, data);
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                padding: 25,
                callback: function (value) {
                  return value
                    .toString()
                    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1’");
                },
              },
            },
          ],
          xAxes: [
            {
              // barThickness: 25,  // number (pixels) or 'flex'
              // maxBarThickness: 30 // number (pixels)
            },
          ],
        },
      },
      project: {
        name: "",
        start_date: null,
        end_date: null,
        description: "",
        target_cost: null,
        static_budget: null,
        dynamic_buget: null,
        actual_costs: null,
        status: true,
        profile_image: null,
        total_costs_project_leader: 0,
        created_by: null,
        color: null,
      },
    };
  },
  created() {
    if (this.$router.currentRoute.name === "EditProject") {
      this.isUpdateProject = true;
      this.get(this.apiPrefix, this.projectApiUrl, this.$route.params.id)
        .then((resp) => {
          this.project = resp.data;
          this.setDefaultDateForMonthPicker(
            this.project.start_date,
            this.project.end_date
          );

          // refresh invoiced amount component to show the actual figure
          this.componentKey += 1;
          if (resp.data.profile_image)
            this.project.profile_image = resp.data.profile_image.image;
          this.getConsolidationData();
          this.usersOnProject = resp.data.project_sheets.map((obj) => {
            let val = obj.user;
            val["sheet"] = obj.id;
            val["job"] = obj.job !== null ? obj.job : { name: "" };
            return val;
          });
        })
        .catch((err) => {
          console.log(err);
        });

      this.getList(this.apiPrefix, this.jobApiUrl)
        .then((resp) => {
          this.jobs = resp.data;

          this.getList(
            this.apiPrefix,
            this.userApiUrl,
            this.jobFilter !== ""
              ? `/?jobs__name__iexact=${this.jobFilter}&is_superuser=False`
              : `/?is_superuser=False`
          )
            .then((resp) => {
              this.usersList = this.filterDuplicates(resp.data, "id");
            })
            .catch((err) => {
              console.log(err.response);
            });
        })
        .catch((err) => {
          console.log(err.response);
        });

      this.getArchiveList();
    }
    this.getList(this.apiPrefix, this.userApiUrl + `/get-all-superusers/`)
      .then((resp) => {
        this.superusers = resp.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
  methods: {
    updateSendEmailAlerts(){
        let msg = this.$t("message.emailAlertSettingChangedSuccesfully");

        this.update(
          this.apiPrefix,
          this.projectApiUrl,
          this.project.id,
          this.project
        )
          .then(() => {
            this.$modal.show(
              OkModal,
              {
                text: msg,
                modalClass: this.modalClasses.okSuccessClass,
              },
              {
                width: this.modalWidth(),
                height: "auto",
              }
            );
          })
          .catch((err) => {
            let msg = this.createErrorMessage(
              this.parseErrors(err.response.data.errors)
            );
            // msg += invalidDatesMsg

            this.$modal.show(
              OkModal,
              {
                text: msg,
                modalClass: this.modalClasses.okErrorClass,
              },
              {
                width: this.modalWidth(),
                height: "auto",
              }
            );
          });
    },
    //method for retrieving the list of archives
    getArchiveList() {
      this.get(
        this.apiPrefix,
        this.projectApiUrl + "get-archives-per-project/",
        this.$route.params.id
      )
        .then((resp) => {
          this.archives = resp.data.map((row) => ({
            id: row.id,
            url: row.url,
            created: this.$moment(row.created).format("YYYY-MM-DD hh:mm"),
            completed: row.completed
          }));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getArchiveStatus(archiveId){
        console.log(archiveId)
         this.get(
        this.apiPrefix,
        this.projectApiUrl + "get-archive/",
        archiveId
      )
        .then((resp) => {
              // in case the archive has not been completed, check it again
              // after 10 seconds, else set the respective archive in the array
              // of archives as completed
              if(resp.data["completed"] === false){
                setTimeout(() => this.getArchiveStatus(archiveId), 10000);
              }else{
                    for(let i=0; i<this.archives.length; i++){
                      if(this.archives[i].id === archiveId){
                        this.archives[i].completed = true;
                      }
                    }
              }
         }
        )
        .catch((err) => {
          console.log(err);
        });

    },
    createArchive() {
      this.get(
        this.apiPrefix,
        this.projectApiUrl + "create-archive/",
        this.$route.params.id
      )
        .then((resp) => {

          let url = resp.data["url"];
          let text = `${this.$t("message.archiveZipFile")}: ${url}`;

          this.$modal.show(
            OkModal,
            {
              text: text,
              modalClass: this.modalClasses.okSuccessClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
          this.getArchiveList();
          this.getArchiveStatus(resp.data["id"])
          // get file name from header disposition
          // let disposition = resp.headers['content-disposition']
          // let fileName = disposition.substring(disposition.indexOf('-') + 1)

          // let element = document.createElement('a');
          // element.setAttribute('href', 'data:text/plain;base64,' + resp.data);
          // element.setAttribute('download', fileName);

          // element.style.display = 'none';
          // document.body.appendChild(element);

          // element.click();

          // document.body.removeChild(element);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goToLock() {
      this.$router.push({
        name: "LockMonths",
        params: {
          id: this.project.id,
          start_date: this.project.start_date,
          end_date: this.project.end_date,
        },
      });
    },
    goToTaskHistory() {
      this.$router.push({
        name: "TaskHistory",
        params: { id: this.project.id },
      });
    },
    emitColor(data) {
      this.project.color = data;
    },
    refreshConsolidation() {
      this.getConsolidationData();
    },
    updateTotalCostsProjectLeader(variable) {
      this.project.total_costs_project_leader = variable;
    },
    // generalMixin method for returning the array of correct colors for vertical bars rolling forecast
    getVerticalBarColors(dates) {
      return this.getBarColors(dates);
    },
    downloadToCsv() {
      this.getList(
        this.apiPrefix,
        this.projectApiUrl + "cost-lines-per-project/",
        `${this.$route.params["id"]}`
      )
        .then((resp) => {
          let data = resp.data.data;

          if (data.length > 0) {
            const mappedData = data.map((row) => ({
              date: row[0],
              job: row[1],
              company_name: row[2],
              category_type: row[3],
              category_name: row[4],
              price: row[5],
              amount: row[6],
              total: row[7],
              actualOrBudget: row[8] ? "actual" : "budget",
            }));

            let csvData = this.objectToCsv(mappedData);
            this.download(csvData);
          }
        })
        .catch(() => {
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    objectToCsv(data) {
      let csvRows = [];

      //get the headers
      let headers = Object.keys(data[0]);
      csvRows.push(headers.join(","));

      // loop over the rows
      for (const row of data) {
        let values = headers.map((header) => {
          // form escaped comma separated values
          ("" + row[header.replace]).replace(/"/g, '\\"');
          return `${row[header]}`;
        });
        csvRows.push(values.join(","));
      }

      return csvRows.join("\n");
    },
    download(data) {
      let blob = new Blob([data], { type: "text/csv" });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.setAttribute("hidden", "");
      a.setAttribute("href", url);

      let documentName = this.project.name + ".csv";
      a.setAttribute("download", documentName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    returnImage() {
      if (this.project.profile_image) return this.project.profile_image;
      return this.altPic;
    },
    addImage(event) {
      // in case uploaded file is jpg or png else alert error
      if (this.isFileImage(event.target.files[0])) {
        const fd = new FormData();

        fd.append("image", event.target.files[0], event.target.files[0].name);
        this.update(
          this.apiPrefix,
          this.projectApiUrl + "profile-image/",
          this.$route.params.id,
          fd
        )
          .then((res) => {
            this.project.profile_image = res.data.image;
            document.getElementById("imageInput").value = "";
            this.$modal.show(
              OkModal,
              {
                text: this.$t("message.coverImageSuccesfullyUpdated"),
                modalClass: this.modalClasses.okSuccessClass,
              },
              {
                width: this.modalWidth(),
                height: "auto",
              }
            );
          })
          .catch((err) => {
            console.log(err.response);
            this.$modal.show(
              OkModal,
              {
                text: this.$t("message.oopsSomethingWentWrong"),
                modalClass: this.modalClasses.okErrorClass,
              },
              {
                width: this.modalWidth(),
                height: "auto",
              }
            );
          });
      } else {
        this.$modal.show(
          OkModal,
          {
            text: this.$t("message.provideCorrectFormat"),
            modalClass: this.modalClasses.okErrorClass,
          },
          {
            width: this.modalWidth(),
            height: "auto",
          }
        );
      }
    },
    isFileImage(file) {
      const acceptedImageTypes = ["image/gif", "image/jpeg", "image/png"];
      return file && acceptedImageTypes.includes(file["type"]);
    },
    getConsolidationData() {
      this.get(
        this.apiPrefix,
        this.projectApiUrl + "consolidation/",
        "",
        this.$route.params.id
      )
        .then((resp) => {
          this.horizontalBarDataCollection = null;
          this.consolidationData = resp.data.data;

          // add a filter_match property to consolidation data array
          this.consolidationData = Object.values(this.consolidationData).map(
            (obj) => ({
              ...obj,
              filter_matched: true,
              company_name_lower: obj.company_name.toLowerCase(),
            })
          );

          this.project.dynamic_budget = this.sumAllCosts("dynamic_budget");
          this.project.actual_costs = this.sumAllCosts("actual_costs");
          this.project.target_cost = this.sumAllCosts("target_cost");
          this.project.static_budget = this.sumAllCosts("static_budget");
          this.project.total_invoiced = this.sumAllCosts("total_invoiced");
          // let dates = resp.data.rolling_forecast.dates
          // let total_costs = resp.data.rolling_forecast.total_costs
          // let colors = []

          //  // determine color of the bar as per it's date
          // for(let i=0; i<dates.length; i++){
          //    let date = new Date(dates[i])
          //    if (date.getMonth() > new Date().getMonth() && date.getFullYear() >= new Date().getFullYear())
          //       colors.push('red')
          //    else
          //      colors.push('green')
          // }

          // rolling forecast is the sum of actual costs and future budget costs returned in the request
          // let budget_future = 0
          // if (resp.data.budget_future)
          //   budget_future = resp.data.budget_future

          // getting the rolling forecast bar by suming the array of rolling forecast per month by using reduce method
          this.project.rolling_forecast = resp.data.rolling_forecast.total_costs.reduce(
            (a, b) => a + b,
            0
          );

          //this.project.name = ''
          let data = [
            this.project.target_cost,
            this.project.static_budget,
            this.project.dynamic_budget,
            this.project.actual_costs,
            this.project.rolling_forecast,
            resp.data.additional_budget,
          ];
          this.stackedChartDataCollection = this.parseDataForStackedChart(data);

          this.horizontalBarDataCollection = this.parseDataForChartTotal(
            data,
            "#f87979",
            [
              this.$t("message.targetCost"),
              this.$t("message.staticBudget"),
              this.$t("message.dynamicBudget"),
              this.$t("message.actualCosts"),
              this.$t("message.rollingForecast"),
            ]
          );
          //this.barDataCollection=this.parseDataForChartTotal(total_costs, colors , dates)

          // consolidate data and assign them to global variables
          let completeData = this.consolidateData(resp);

          let backgroundColorsBars = this.getVerticalBarColors(
            resp.data.budget_history.dates
          );

          this.mixedChartDataCollection = this.parseDataForMixedChartTotal(
            completeData.mixedRollingForecastCosts,
            completeData.mixedTotalBudgetHistory,
            this.$t("message.rollingForecast"),
            this.$t("message.budgetHistory"),
            completeData.mixedDates,
            backgroundColorsBars
          );
        })
        .catch((err) => {
          console.log(err);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    // sum all costs for the specified row
    sumAllCosts(typeOfCosts) {
      let sumOfCosts = 0;
      for (let k in this.consolidationData) {
        if (this.consolidationData.hasOwnProperty(k)) {
          sumOfCosts += this.consolidationData[k][typeOfCosts];
        }
      }
      return sumOfCosts;
    },
    parseDataForStackedChart(data) {
      const chartData = {
        labels: [
          this.$t("message.targetCost"),
          this.$t("message.staticBudget"),
          this.$t("message.actualCosts"),
          //  this.$t('message.dynamicBudget'),
          this.$t("message.rollingForecast"),
        ],
        datasets: [
          {
            barThickness: 17,
            label: this.$t("message.data"),
            backgroundColor: "rgba(236, 72, 78, 0.5)",
            hoverBackgroundColor: "rgba(236, 72, 78, 1)",
            data: [data[0], data[1], data[3], data[4]],
          },
          {
            barThickness: 17,
            label: this.$t("message.additionalBudget"),
            backgroundColor: "rgba(74, 167, 222, 0.5)",
            hoverBackgroundColor: "rgba(74, 167, 222, 1)",
            data: [0, data[5], 0, data[5], data[5]],
          },
        ],
      };

      return chartData;
    },
    parseDataForChartTotal(data, color, labels) {
      return {
        labels: labels,
        datasets: [
          {
            barThickness: 12,
            backgroundColor: color,
            data: data,
          },
        ],
      };
    },
    parseDataForMixedChartTotal(
      rollingForecast,
      budgetTotal,
      labelLine,
      labelBars,
      labels,
      backgroundColorsBars
    ) {
      return {
        labels: labels,
        datasets: [
          {
            // one line graph
            label: labelLine,
            type: "line",
            data: rollingForecast,
            backgroundColor: "rgba(93,184,100,.5)",
          },
          {
            // bar graph
            label: labelBars,
            barThickness: 25,
            type: "bar",
            data: budgetTotal,
            backgroundColor: backgroundColorsBars,
          },
        ],
      };
    },
    // method for creating consolidated data from rolling forecast and budgets
    consolidateData(resp) {
      return this.consolidate(resp);
    },
    // DELETION
    confirmDeleteUserFromProject(data) {
      this.delete(this.apiPrefix, this.sheetApiUrl, data.sheet)
        .then(() => {
          this.usersOnProject = this.usersOnProject.filter((user) => {
            return data.sheet !== user.sheet;
          });
        })
        .catch((err) => {
          console.log(err.response);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    removeFromListDialog(element) {
      this.$modal.show(
        DialogModal,
        {
          text: `${this.$t("message.confirmRemove")} ${element.first_name} ${
            element.last_name
          } ${this.$t("message.fromTheProject")}?`,
          param: element,
          textColor: "#c44133",
          event: "confirmDelete",
        },
        {
          width: this.modalWidth(),
          height: "auto",
        }
      );
    },
    // ADDING
    addUserToProjectDialog(user, jobName) {
      this.jobFilter = jobName;
      if (this.jobFilter === "") {
        this.$modal.show(
          OkModal,
          {
            text: this.$t("message.mustSelectBKP"),
            modalClass: this.modalClasses.okErrorClass,
          },
          {
            width: this.modalWidth(),
            height: "auto",
          }
        );
        return;
      }

      for (let u of this.usersOnProject) {
        if (u.id === user.id && u.job.name === this.jobFilter) {
          this.$modal.show(
            OkModal,
            {
              text: `${this.$t("message.user")} ${user.first_name} ${
                user.last_name
              } ${this.$t("message.withJob")} ${this.jobFilter} ${this.$t(
                "message.isAlreadyOnProject"
              )}.`,
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
          return;
        }
      }
      this.$modal.show(
        DialogModal,
        {
          text:
            `<p>${this.$t("message.areYouSureYouWantAddUser")}</p>` +
            `<p class="font-bold">${this.$t("message.firstName")}: ${
              user.first_name
            } ` +
            `${this.$t("message.lastName")}: ${user.last_name}</p>` +
            `<p class="font-bold">${this.$t("message.companyName")}: ${
              user.company_name
            }</p>` +
            (this.jobFilter !== ""
              ? `<p class="font-bold">${this.$t("message.jobTypeOnProject")}: ${
                  this.jobFilter
                }</p>`
              : `<p class="font-bold">${this.$t(
                  "message.noJobSelected"
                )}. </p>`),
          param: user,
          event: "confirmAdd",
          date: true,
        },
        {
          width: this.modalWidth(),
          height: "auto",
        }
      );
    },
    confirmAddUserToProject(data) {
      const user = data.user;
      // let self = this

      // set job
      const job = this.jobs.filter((job) => {
        return job.name === this.jobFilter;
      });

      let jobId = "";
      if (job.length !== 0) {
        jobId = job[0].id;
      }

      const params = {
        user_id: user.id,
        job_id: jobId,
        project_id: this.$route.params["id"],
        contract_number: data.contract_number,
        static_budget: data.static_budget,
        user: data.user,
      };

      // set date if it is selected
      if (data.date) {
        params["start_date"] = data.date;
      }
      this.addUserToProject(params);
    },
    addUserToProject(params) {
      this.post(this.apiPrefix, this.sheetApiUrl, "", params)
        .then((resp) => {
          params.user["sheet"] = resp.data.object.id;
          const job = resp.data.object.job;
          params.user["job"] = job !== undefined ? job : { name: "" };
          this.usersOnProject.push(params.user);

          let text = `${this.$t("message.user")} ${params.user.first_name} ${
            params.user.last_name
          } ${this.$t("message.successfullyAddedToProject")}.`;

          // check if contract number is empty or only spaces and add additional text
          if (
            !params["contract_number"] ||
            params["contract_number"].replace(/\s/g, "").length == 0
          )
            text = `${text} ${this.$t(
              "message.informAutomaticContractNumber"
            )}`;

          this.$modal.show(
            OkModal,
            {
              text: text,
              modalClass: this.modalClasses.okSuccessClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        })
        .catch((err) => {
          let msg = this.createErrorMessage(
            this.parseErrors(err.response.data.errors)
          );

          this.$modal.show(
            OkModal,
            {
              text: msg,
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
          console.log(err.response);
        });
    },
    informAutomaticContractNumber() {
      this.$modal.show(
        OkModal,
        {
          text: `<p>${this.$t("message.informAutomaticContractNumber")}</p>`,
          modalClass: this.modalClasses.okSuccessClass,
        },
        {
          width: this.modalWidth(),
          height: "auto",
        }
      );
    },
    addUpdateProject() {
      let self = this;

      // format date
      if (this.project.start_date) {
        this.project.start_date = this.$moment(this.project.start_date).format(
          "YYYY-MM-DD"
        );
      }

      if (this.project.end_date) {
        this.project.end_date = this.$moment(this.project.end_date).format(
          "YYYY-MM-DD"
        );
      }

      // check if end date is later than start date
      // let invalidDatesMsg = ''
      // if (this.project.start_date && this.project.end_date) {
      //   if (this.project.start_date > this.project.end_date) {
      //     invalidDatesMsg = `${this.$t('message.startDate')}: ${this.$t('message.startDateLater')}`
      //   }
      // }

      let msg = "";

      if (this.isUpdateProject) {
        msg = this.$t("message.projectUpdatedSuccessfully");

        this.update(
          this.apiPrefix,
          this.projectApiUrl,
          this.project.id,
          this.project
        )
          .then(() => {
            self.$modal.show(
              OkModal,
              {
                text: msg,
                modalClass: self.modalClasses.okSuccessClass,
              },
              {
                width: self.modalWidth(),
                height: "auto",
              }
            );
          })
          .catch((err) => {
            let msg = self.createErrorMessage(
              self.parseErrors(err.response.data.errors)
            );
            // msg += invalidDatesMsg

            self.$modal.show(
              OkModal,
              {
                text: msg,
                modalClass: self.modalClasses.okErrorClass,
              },
              {
                width: self.modalWidth(),
                height: "auto",
              }
            );
          });
      } else {
        msg = this.$t("message.projectCreatedSuccessfully");
        //this.project.created_by = this.$store.getters.getAuth['userId']
        this.post(this.apiPrefix, this.projectApiUrl, "", this.project)
          .then(() => {
            self.$modal.show(
              OkModal,
              {
                text: msg,
                modalClass: self.modalClasses.okSuccessClass,
              },
              {
                width: self.modalWidth(),
                height: "auto",
              }
            );
          })
          .catch((err) => {
            let msg = self.createErrorMessage(
              self.parseErrors(err.response.data.errors)
            );

            self.$modal.show(
              OkModal,
              {
                text: msg,
                modalClass: self.modalClasses.okErrorClass,
              },
              {
                width: self.modalWidth(),
                height: "auto",
              }
            );
          });
      }
    },
    // addImage () {
    //   this.$modal.show(UploadImageModal, {
    //     heading: this.$t('message.coverImage'),
    //     uploadRoute: ''
    //   }, {
    //     width: '300px',
    //     height: 'auto'
    //   })
    //}
    formatNumber(input) {
      // format is function in generalMixin.js
      return this.format(input);
    },
    filterUsers() {
      this.getList(
        this.apiPrefix,
        this.userApiUrl,
        `/?company_name__istartswith=${this.companyFilter}&is_superuser=False`
      )
        .then((resp) => {
          this.usersList = this.filterDuplicates(resp.data, "id");
        })
        .catch((err) => {
          console.log(err.response);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
  },
};
</script>

<style scoped>
label {
  font-weight: bold;
}

.companies-list-wrapper {
  background-color: rgba(220, 220, 220, 0.2);
  min-height: 430px;
  max-height: 430px;
  overflow: scroll;
}

.list-group-2 {
  min-height: 43px;
}

.list-group {
  margin-bottom: 6px;
}

.list-group-item {
  border: 1px solid #ebecf0;
}

.list-group-item i {
  cursor: pointer;
}

.remove-from-list {
  color: grey;
  position: absolute;
  right: 7px;
  top: 8px;
}

.user-info {
  position: absolute;
  right: 28px;
  top: 12px;
}

.user-add {
  position: absolute;
  right: 10px;
  top: 12px;
}

div.gallery {
  margin: 5px;
  border: 1px solid rgb(214, 214, 214);
  padding: 5px;
  border-radius: 4px;
  float: left;
  width: 180px;
  height: 140px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

div.gallery:hover {
  box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
}

div.gallery img {
  margin: 4%;
  width: 92%;
  height: auto;
}

select {
  font-size: 13px;
}

.box {
  float: left;
  height: 20px;
  width: 20px;
  margin-bottom: 15px;
  border: 1px solid black;
  clear: both;
}

.radio {
  margin-left: 5px;
  margin-top: -5px;
}

.legend {
  list-style: none;
  display:flex;
  justify-content: center;
}

.legend li {
  display: list-item;
  margin-right: 10px;
  
}

.span {
  border: 1px solid #ccc;
  float: left;
  width: 20px;
  height: 20px;
  margin: 2px;
}


.completed{
  background: green;
  border: 1px solid #ccc;
}

.not-completed{
  background: red;
}

</style>
